import { __extends } from "tslib";
/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { Modal } from 'react-bootstrap';
import Tabla from '../Tabla';
// eslint-disable-next-line @typescript-eslint/ban-types
var ModalBusqueda = /** @class */ (function (_super) {
    __extends(ModalBusqueda, _super);
    function ModalBusqueda(p) {
        var _this = _super.call(this, p) || this;
        _this.variant = 'bg-info';
        _this.Title = _this.Title.bind(_this);
        return _this;
    }
    ModalBusqueda.prototype.Title = function () {
        return React.createElement(React.Fragment, null);
    };
    ModalBusqueda.prototype.render = function () {
        var _a = this, Body = _a.Body, Buscador = _a.Buscador, Title = _a.Title, _b = _a.props, open = _b.open, close = _b.close;
        return (React.createElement(Modal, { show: open, onHide: close, size: 'xl' },
            React.createElement(Modal.Header, { className: this.variant, closeButton: true },
                React.createElement(Title, null)),
            React.createElement(Modal.Body, null,
                React.createElement("div", { style: { padding: '10px 10px 10px 10px', overflowX: 'scroll' } },
                    React.createElement(Buscador, null),
                    React.createElement(Body, null)))));
    };
    ModalBusqueda.prototype.reset = function () { };
    ModalBusqueda.prototype.set = function () { };
    ModalBusqueda.prototype.componentDidMount = function () {
        this.set();
    };
    return ModalBusqueda;
}(Tabla));
export default ModalBusqueda;
//# sourceMappingURL=Modal.js.map